//src/pages/_app.tsx
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { Navbar, Header, Footer } from './../components';
import type { NavbarProps } from './../interfaces';

// ── CHANGED: import design tokens BEFORE globals so every module can read them.
import '../styles/tokens.css';
import '../styles/globals.css';

function MyApp({ Component, pageProps }: AppProps) {
  // Navbar builds its own items synchronously from the build-time path list, so
  // it renders complete on the server. This used to load them in an effect and
  // pass them down, which left the SSR markup showing "Loading navigation..."
  // until hydration — permanently, on any browser that can't hydrate.
  const navbarProps: NavbarProps = { initialNavItems: [] };

  return (
    <>
      {/* viewport belongs in _app (next/head), not _document */}
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      {/* data-chrome marks the site shell so embed mode (html.embed, set from
         ?embed=1) can hide it — see styles/globals.css. */}
      <div data-chrome>
        <Header />
      </div>

      <main className="pageMain">
        <div data-chrome>
          <Navbar {...navbarProps} />
        </div>
        <Component {...pageProps} />

      </main>
      <div data-chrome>
        <Footer />
      </div>
    </>
  );
}

export default MyApp;
